module.exports = __webpack_public_path__ + "img/Popup_horario_de_corte_PS.46b9c54a.png";